var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper fill-vh"},[_c('MainInfo'),_c('EmailForm',{attrs:{"namefromquery":_vm.namefromquery,"emailfromquery":_vm.emailfromquery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }